import React from 'react'

import styled from '@emotion/styled'

import { FullWidthButton } from 'components/common/FullWidthButton'
import Bookmark from 'components/common/Bookmark'

const Footer = ({ id, description, onClick, status }) => {
  return (
    <Container>
      <SpaceBetwewen>
        <div>
          <Bookmark store_id={id} />
        </div>
        <RedButton
          onClick={onClick}
          disabled={!status}
          style={{
            backgroundColor: status ? '#ff4a52' : '#ddd',
            cursor: status ? 'pointer' : 'inherit',
          }}
        >
          {description}
        </RedButton>
      </SpaceBetwewen>
    </Container>
  )
}

export default Footer

const Container = styled.footer`
  max-width: 480px;
  width: 100%;
  background-color: white;
  padding: 11px 16px;
  position: fixed;
  bottom: 0;
  background-color: white;
  z-index: 1;

  display: flex;
  justify-content: space-around;
  align-items: center;
`

const SpaceBetwewen = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  div {
    width: 50px;
    height: 50px;
    background-color: #ddd;
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    position: static !important;
    cursor: pointer;
  }
`

const RedButton = styled(FullWidthButton)`
  width: calc(100% - 50px - 16px);
  height: 50px;
  margin: 0;
`
